import React from "react";
import styles from "./index.module.scss";
import Schema from "./Schema";
import {useSearchParams} from "react-router-dom";

export default function FloorSelector() {
    const [searchParams] = useSearchParams();
  return (
    <div style={{}} className={styles.floorSelector}>
        <Schema/>
    </div>
  );
}
